import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { clearCategory, clearText, IElement, RouteElementService } from 'dbweb-core';
function label(e: IElement) {
	if (e.Label) {
		return clearText(e.Label);
	}
	return clearText(e.Name);
}
@Injectable({
	providedIn: 'root'
})
export class HomeTabfunctionService {
	constructor(public eles: RouteElementService) {}
	get category() {
		return this.eles.currentElementListen.pipe(
			map(v => (v ? clearCategory(v.element.Category).replace('/', '>') + '>' + label(v.element) : null))
		);
	}
}
